var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('p',{staticClass:"control is-expanded"},[_c('vue-single-select',{attrs:{"options":_vm.options,"option-label":"text","placeholder":"Select Manager","max-height":"150px","classes":{
                    input: 'input',
                    dropdown: 'user-select-drop-down'
                }},model:{value:(_vm.managerId),callback:function ($$v) {_vm.managerId=$$v},expression:"managerId"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b409a9b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/User/Transfer/ManagerSelect.vue
// module id = null
// module chunks = 